export const CUSTOM_ATTRIBUTE_NAME = "data-event-intersection";
